import {RouteTypename} from '@src/Navigation/types/route.type';
import useTracker from '~Services/Amplitude/hooks/useTracker';
import useTracking from '@src/Tracking/useTracking';
import {TraceTokEvents} from '@src/Tracking/catalog';

const useShareContent = (options?: {screenSource?: 'discover' | 'detail'}) => {
  const {screenSource} = options || {};
  const tracker = useTracker();
  const {emit} = useTracking();

  const share = async (params: {
    url: string;
    id: string;
    __typename: RouteTypename;
    message?: string;
    episode?: number;
    category?: string;
    cover: string;
    description: string;
    title?: string;
    countryOfProduction?: Array<string | undefined> | string;
  }) => {
    const {
      id,
      __typename,
      message,
      url,
      cover,
      description,
      category,
      title,
      countryOfProduction,
    } = params;
    const countryArray = Array.isArray(countryOfProduction)
      ? countryOfProduction
      : [countryOfProduction];

    // discover_slide_shared: no canonical equivalent, kept (legacy, snake_case)
    if (screenSource === 'discover') {
      tracker.discover.discoverSlideShare({
        title: message || '',
        id: id,
        __typename: __typename,
        url: url,
        name: message,
        countryOfProduction: countryArray,
      });
    }
    // content_shared (canonical) — fires regardless of source
    emit(TraceTokEvents.ContentShared, {
      content_id: id,
      content_type: __typename,
      share_channel: 'web',
    });
  };
  return {share};
};

export default useShareContent;
